var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pg-main"},[_c('p-g-header'),_c('main',[_c('router-view')],1),_c('p-g-footer'),_c('f-window',{ref:"successModal",staticStyle:{"max-width":"345px"}},[_c('p-g-success-notification')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }